module.exports = __webpack_public_path__ + "static/main_bg-d1778131c556560767142a862b883c89.svg";